export default __webpack_public_path__ + "static/media/placeholder_portfolio04-nl-mobile.7b922d4c.png";